import React from 'react';

export const renderMarkdown = (content, options = {}) => {
    const { isCompact = false, useWhiteText = false, customClasses = '' } = options;
    
    // console.log('[MARKDOWN RENDER DEBUG]', {
    //     contentLength: content?.length,
    //     contentType: typeof content,
    //     hasHtmlLinks: content?.includes && content.includes('<a href='),
    //     hasCitationNumbers: content?.includes && content.includes('[') && content.includes(']'),
    //     contentPreview: content?.substring && content.substring(0, 200) + '...'
    // });
    
    if (typeof content !== 'string') {
        return <div className={`whitespace-pre-line ${useWhiteText ? 'text-white' : ''}`}>{content ?? ''}</div>;
    }
   
    let cleanedContent = content;
    
    // Pre-process to handle bold text with Chinese characters and special punctuation
    cleanedContent = cleanedContent.replace(/\*\*([^*]+)\*\*/g, (match, p1) => {
        // Check if content contains Chinese characters
        if (/[\u4e00-\u9fa5]/.test(p1)) {
            return `<strong>${p1}</strong>`;
        }
        return match;
    });
    
    if (window.marked) {
        try {
            window.marked.setOptions({
                breaks: true,
                gfm: true,
                headerIds: false,
                mangle: false,
                sanitize: false, // Allow HTML tags we're injecting
                highlight: function(code, lang) {
                    if (lang && window.hljs) {
                        try {
                            return window.hljs.highlight(code, { language: lang }).value;
                        } catch (err) {
                            return code;
                        }
                    }
                    return code;
                }
            });
           
            const htmlOutput = window.marked.parse(cleanedContent);
            
            // console.log('[MARKDOWN PARSE DEBUG]', {
            //     inputHasHtmlLinks: cleanedContent.includes('<a href='),
            //     outputHasHtmlLinks: htmlOutput.includes('<a href='),
            //     outputPreview: htmlOutput.substring(0, 300) + '...'
            // });
            
            let proseClasses = '';
            
            if (customClasses) {
                // Use custom classes if provided (for UserProfileModal)
                proseClasses = customClasses;
            } else if (isCompact) {
                // For compact mode (like in choices), use minimal prose styling
                proseClasses = "prose prose-sm prose-slate max-w-none prose-p:my-0 prose-headings:my-1 prose-ul:my-0 prose-ol:my-0 prose-li:my-0 prose-blockquote:my-1 prose-pre:my-1";
            } else if (useWhiteText) {
                // For white text mode (used in App.js)
                proseClasses = `prose prose-sm max-w-none prose-p:text-white prose-h1:text-white prose-h2:text-white prose-h3:text-white prose-h4:text-white prose-h5:text-white prose-h6:text-white prose-strong:text-white prose-em:text-white prose-code:text-white prose-pre:text-white prose-blockquote:text-white prose-ol:text-white prose-ul:text-white prose-li:text-white prose-a:text-white`;
            } else {
                // Default prose styling
                proseClasses = 'prose prose-sm prose-slate max-w-none';
            }
            
            return (
                <div
                    className={proseClasses}
                    dangerouslySetInnerHTML={{ __html: htmlOutput }}
                />
            );
        } catch (error) {
            console.error('Markdown parsing error:', error);
            return <div className={`whitespace-pre-line ${useWhiteText ? 'text-white' : ''}`}>{cleanedContent}</div>;
        }
    }
    
    // Fallback if marked is not available
    return <div className={`whitespace-pre-line ${useWhiteText ? 'text-white' : ''}`}>{cleanedContent}</div>;
};